
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.28 26.116a6.667 6.667 0 100-13.334 6.667 6.667 0 000 13.334zM21 31.116a12.5 12.5 0 0120 0","stroke":"#56BFC7","stroke-width":"2.2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M49.719 53.474V8.191c0-1.137-.85-2.059-1.9-2.059h-34.2c-1.05 0-1.9.922-1.9 2.059v45.283c0 1.137.85 2.058 1.9 2.058h34.2c1.05 0 1.9-.921 1.9-2.058zM19 41.232h19M19 46.232h9.5","stroke":"#fff","stroke-width":"2.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    